import styled from 'styled-components';

export const CurriculumCardContainer = styled.div`
  display: flex;
  width: 150px;
  margin: 10px;
  
  .card-content {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    min-height: 150px;
    border: 1px solid #cccccc;
    padding: 10px;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    p {
      text-align: center;
      font-size: 14px;
      color: #000000;
      font-weight: bold;
      margin: 0 0 10px 0;
      flex-shrink: 0;
      word-wrap: break-word;
      overflow-wrap: break-word;
    }
    :hover {
      border: 2px solid #9ddfdd;
      cursor: pointer;
    }
    img {
      align-self: center;
      max-width: 100%;
      height: auto;
      flex-shrink: 0;
    }
  }
  .selected {
    background-color: #ebf9ff;
    border: 1px solid #9ddfdd;
  }
`;
